import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Button, Toast } from 'react-bootstrap';
import { RootState } from 'store'; // Adjust import path

import { useAppContext } from 'providers/AppProvider';

const CodeDisplayCard: React.FC = () => {
  // The widget license is the account's public_token (surfaced by the backend);
  // fall back to license_uuid for older sessions.
  const token = useSelector(
    (state: RootState) => state.auth.widget_license || state.auth.license_uuid
  );
  const [showToast, setShowToast] = useState(false);

  const {
    config: { isDark }
  } = useAppContext();

  const codeSnippet = `<!-- Begin EasyChatDesk widget -->
<script>
  window.__ecd = { license: '${token}' };
</script>
<script src="https://cdn.easychatdesk.com/widget.min.js" async></script>
<!-- End EasyChatDesk widget -->`;

  const handleCopy = () => {
    navigator.clipboard.writeText(codeSnippet);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000); // Hide toast after 2 seconds
  };

  return (
    <>
      <Card style={{ width: '100%', marginTop: '20px' }}>
        <Card.Body>
          <Card.Title>EasyChatDesk Widget Code</Card.Title>
          <p>
            Copy and paste this code in your website page. Preferably right before the {'</body>'} tag closes.
          </p>
          <pre style={{ background: isDark ? '#333' : "#f0f0f0", padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap' }}>
            {codeSnippet}
          </pre>
          <Button variant="success" className="mt-3" onClick={handleCopy}>
            Copy to Clipboard
          </Button>


          <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={2000}
        autohide  style={{marginTop: 15, backgroundColor: "green",   color:"white"}}
      >
        <Toast.Body>Code copied to clipboard!</Toast.Body>
      </Toast>


        </Card.Body>
      </Card>

 
      
    </>
  );
};

export default CodeDisplayCard;
